module.exports = __webpack_public_path__ + "img/21.c06d3522.jpg";